import Image from "next/image"
import { Airline } from "@/types/flights/airline"

import IconPlane from "@/components/icons/plane"
import IconPlaneMultiTrip from "@/components/icons/plane-multi-trip"

export interface AirlinesImgProps {
  airlines: Airline[]
  logoSize?: number
  iconSize?: number
  className?: string
  lazy?: boolean
}
export function AirlinesImg({
  airlines,
  iconSize = 24,
  logoSize = 24,
  className,
  lazy = true,
}: AirlinesImgProps) {
  if (
    airlines.length === 0 ||
    (airlines.length === 1 && airlines[0]?.logo_url == null)
  ) {
    return (
      <div className="flex items-center">
        <IconPlane size={iconSize} />
      </div>
    )
  } else if (airlines.length === 1) {
    const airlineImg = (
      <Image
        src={airlines[0]?.logo_url ?? ""}
        alt={airlines[0]?.name ? `${airlines[0].name} logo` : ""}
        width={logoSize}
        height={logoSize}
        className={className}
        loading={lazy ? "lazy" : "eager"}
      />
    )

    return airlineImg
  } else {
    return (
      <div className="flex items-center">
        <IconPlaneMultiTrip size={iconSize} />
      </div>
    )
  }
}
